import { client, checkAndParseResponse, parseAxiosError } from "@/api";

export async function getStorefrontCatalog(shortcode) {
  try {
    const apiResponse = await client.get(`storefront/${shortcode}/catalog`);
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function createOrder(storefrontId, orderItems) {
  try {
    const oRequest = {
      storefrontId,
      orderItems
    };
    const apiResponse = await client.post(`order`, oRequest);
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function getOrder(orderId) {
  try {
    const apiResponse = await client.get(`order/${orderId}`);
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function removeKidFromOrder(orderId, kidId) {
  try {
    const apiResponse = await client.delete(`order/${orderId}/kid/${kidId}`);
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function addKidToOrder(orderId, kidId) {
  try {
    const apiResponse = await client.post(`order/${orderId}/kid`, {
      kid_id: kidId
    });
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function updateOrderItems(orderId, orderItems) {
  try {
    const apiResponse = await client.put(`order/${orderId}/items`, {
      orderItems: orderItems
    });
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function updateDeliveryMethod(orderId, isShipped, isPickup) {
  try {
    const apiResponse = await client.put(`order/${orderId}/delivery`, {
      isShipped,
      isPickup
    });
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function setOrderAddress(orderId, oAddressParams) {
  try {
    const apiResponse = await client.put(
      `order/${orderId}/address`,
      oAddressParams
    );
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function setOrderShippingAddress(orderId, oAddressParams) {
  try {
    const apiResponse = await client.put(
      `order/${orderId}/shipping_address`,
      oAddressParams
    );
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function validateOrder(orderId) {
  try {
    const apiResponse = await client.get(`order/${orderId}/validate`);
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function validateParentPasscode(storefrontId, passcode) {
  try {
    const oRequest = {
      passcode
    };
    const apiResponse = await client.post(
      `storefront/${storefrontId}/verify_parent_passcode`,
      oRequest
    );
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function getPeopleOptions(storefrontId, passcode) {
  try {
    const oRequest = {
      passcode
    };
    const apiResponse = await client.post(
      `storefront/${storefrontId}/people_options`,
      oRequest
    );
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}

export async function verifyKidInformation(storefrontId, passcode, oParams) {
  try {
    const oRequest = {
      passcode,
      ...oParams
    };
    const apiResponse = await client.post(
      `storefront/${storefrontId}/verify_kid_information`,
      oRequest
    );
    const apiData = checkAndParseResponse(apiResponse);
    return apiData.data || apiData;
  } catch (err) {
    const handledException = parseAxiosError(err);
    throw handledException;
  }
}
